import React from "react";
import { Option } from "../../../models/option";
import { Step } from "../../../models/step";
import { SubOption } from "../../../models/suboption";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import './StepItem.css';
import { TemplateType } from "../../../utils/templateType";

interface StepItemProps {
  step: Step;
  formData: any;
  submitted: boolean;
  submitting: boolean;
  forkedPriceMin: any;
  forkedPriceMax: any;
  onSelect: (optionId: number, optionField: string, subOptionId?: number, subOptionField?: string) => void;
  onTextInputChange?: (value: string, field: string) => void;
  onSubmit: () => void;
  onStartNewRequest: () => void;
  onEditCurrentRequest: () => void;
}

interface StepItemState {
  fadeClass: string;
  currentStep: number;
  previousStep: number;
}

class StepItem extends React.Component<StepItemProps, StepItemState> {
  private defaultFadeClass = 'fadeRightToLeft';

  constructor(props: StepItemProps) {
    super(props);

    this.state = {
      fadeClass: this.defaultFadeClass,
      currentStep: this.props.step.number,
      previousStep: this.props.step.number,
    }
  }

  static getDerivedStateFromProps(nextProps: StepItemProps, prevState: StepItemState) {
    const currentStep = nextProps.step.number;
    const previousStep = prevState.previousStep;

    if (currentStep !== previousStep) {
      const fadeClass = currentStep < previousStep ? 'fadeLeftToRight' : 'fadeRightToLeft';

      return {
        fadeClass: fadeClass,
        currentStep: currentStep,
        previousStep: currentStep, // Update the previous step in the state
      };
    }

    // No change in step, no state update needed
    return null;
  }
  getIsDisabled(itemId: number) {
    let fields = { ...this.props.formData };
    let selectedOptions = fields[this.props.step.field!];

    return this.props.step.multipleOptions === false && selectedOptions.length > 0 && selectedOptions.find((e: Option) => e.id === itemId) == null;
  }

  getLabelClass(itemId: number) {
    return this.getIsDisabled(itemId) ? 'card-disabled' : '';
  }

  onSelect = (optionId: number, optionField?: string, subOptionId?: number, subOptionField?: string) => {
    this.props.onSelect(optionId, optionField ?? this.props.step.field, subOptionId, subOptionField);
  }

  getTemplateType1(option: Option) {
    return (
      <div key={option.key()} className="col-sm-4 d-flex">
        <input type="checkbox" checked={(this.props.formData[this.props.step.field!] as Option[]).find((e: Option) => e.id === option.id) != null} name="device" id={option.key()} onChange={() => this.onSelect(option.id)} hidden />
        <label className={`card card-flex ${this.getLabelClass(option.id ?? -1)}`} htmlFor={option.key()}>
          <div className="checkbox-custom"></div>

          <div className="card-icon">
            {option.icon != null && (
              <img
                src={require(`../../../assets/images/${option.icon}`).default}
                alt="icon"
                className="img-fluid"
              />
            )}
          </div>

          <div className="flex-grow-1">
            <h5>{option.title}</h5>
            <p>
              {option.description}
            </p>
          </div>
        </label>
      </div>
    );
  }

  getTemplateType2(option: Option) {
    return (
      <div key={option.key()} className="col-sm-12">
        <input type="checkbox" checked={(this.props.formData[this.props.step.field!] as Option[]).find((e: Option) => e.id === option.id) != null} name="device" id={option.key()} onChange={() => this.onSelect(option.id)} hidden />
        <label className={`card card-hr d-flex flex-sm-row flex-column align-items-start ${this.getLabelClass(option.id)}`} htmlFor={option.key()}>
          <div className="checkbox-custom checkbox-custom-lg"></div>

          <div className="card-icon">
            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.804 5.625H16.554V5C16.554 4.50272 16.3564 4.02581 16.0048 3.67417C15.6531 3.32254 15.1762 3.125 14.679 3.125H3.42896C2.93167 3.125 2.45476 3.32254 2.10313 3.67417C1.7515 4.02581 1.55396 4.50272 1.55396 5V12.5C1.55396 12.9973 1.7515 13.4742 2.10313 13.8258C2.45476 14.1775 2.93167 14.375 3.42896 14.375H12.179V15C12.179 15.4973 12.3765 15.9742 12.7281 16.3258C13.0798 16.6775 13.5567 16.875 14.054 16.875H17.804C18.3012 16.875 18.7781 16.6775 19.1298 16.3258C19.4814 15.9742 19.679 15.4973 19.679 15V7.5C19.679 7.00272 19.4814 6.52581 19.1298 6.17417C18.7781 5.82254 18.3012 5.625 17.804 5.625ZM3.42896 13.125C3.26319 13.125 3.10422 13.0592 2.98701 12.9419C2.8698 12.8247 2.80396 12.6658 2.80396 12.5V5C2.80396 4.83424 2.8698 4.67527 2.98701 4.55806C3.10422 4.44085 3.26319 4.375 3.42896 4.375H14.679C14.8447 4.375 15.0037 4.44085 15.1209 4.55806C15.2381 4.67527 15.304 4.83424 15.304 5V5.625H14.054C13.5567 5.625 13.0798 5.82254 12.7281 6.17417C12.3765 6.52581 12.179 7.00272 12.179 7.5V13.125H3.42896ZM18.429 15C18.429 15.1658 18.3631 15.3247 18.2459 15.4419C18.1287 15.5592 17.9697 15.625 17.804 15.625H14.054C13.8882 15.625 13.7292 15.5592 13.612 15.4419C13.4948 15.3247 13.429 15.1658 13.429 15V7.5C13.429 7.33424 13.4948 7.17527 13.612 7.05806C13.7292 6.94085 13.8882 6.875 14.054 6.875H17.804C17.9697 6.875 18.1287 6.94085 18.2459 7.05806C18.3631 7.17527 18.429 7.33424 18.429 7.5V15ZM10.929 16.25C10.929 16.4158 10.8631 16.5747 10.7459 16.6919C10.6287 16.8092 10.4697 16.875 10.304 16.875H7.17896C7.01319 16.875 6.85422 16.8092 6.73701 16.6919C6.6198 16.5747 6.55396 16.4158 6.55396 16.25C6.55396 16.0842 6.6198 15.9253 6.73701 15.8081C6.85422 15.6908 7.01319 15.625 7.17896 15.625H10.304C10.4697 15.625 10.6287 15.6908 10.7459 15.8081C10.8631 15.9253 10.929 16.0842 10.929 16.25ZM17.179 8.75C17.179 8.91576 17.1131 9.07473 16.9959 9.19194C16.8787 9.30915 16.7197 9.375 16.554 9.375H15.304C15.1382 9.375 14.9792 9.30915 14.862 9.19194C14.7448 9.07473 14.679 8.91576 14.679 8.75C14.679 8.58424 14.7448 8.42527 14.862 8.30806C14.9792 8.19085 15.1382 8.125 15.304 8.125H16.554C16.7197 8.125 16.8787 8.19085 16.9959 8.30806C17.1131 8.42527 17.179 8.58424 17.179 8.75Z" fill="currentColor" />
            </svg>
          </div>

          <div className="flex-grow-1">
            <h5>
              {option.title}
            </h5>
            <p>
              {option.description}
            </p>
          </div>
        </label>
      </div>
    )
  }

  getTemplateType3(option: Option) {
    const currentOption = (this.props.formData[this.props.step.field!] as Option[]).find((e: Option) => e.id === option.id);

    let show = '';
    if (currentOption) {
      if ((currentOption.subOptions?.length ?? 0) > 0) {
        const subFunctions = (this.props.formData['subFunctions'] as SubOption[]).filter((e: SubOption) => e.optionId === option.id);
        if ((subFunctions?.length ?? 0) > 0) {
          show = 'show';
        }
      }
    }

    return (
      <>
        <div key={option.key()} className="col-sm-12">
          <div className="accordion" id="accordionComponent">
            <div className="accordion-item">
              <input type="checkbox" checked={currentOption != null} name="accordion" id={option.key()} onChange={() => this.onSelect(option.id)} hidden />
              <div className="card">
                <label htmlFor={option.key()} className="checkbox-custom accordion-checkbox checkbox-custom-lg" data-bs-toggle="collapse" data-bs-target={`#${option.key()}`} aria-expanded="false" aria-controls={option.key()}></label>
                <h5 className="accordion-header">
                  <button className={`accordion-button collapsed ${option.subOptions === null || option.subOptions?.length === 0 ? 'non-collapsible' : ''}`} onClick={() => this.onSelect(option.id)} type="button" data-bs-toggle="collapse" data-bs-target={`#${option.key()}`} aria-expanded="false" aria-controls={option.key()}>
                    <div>
                      <p>{option.title}</p>
                      {option.description && (
                        <p className="option-description">{option.description}</p>
                      )}
                    </div>
                  </button>
                </h5>

                {option.subOptions && option.subOptions.length > 0 && (
                  <div id={option.key()} className={`accordion-collapse collapse ${show}`}>
                    <div className="accordion-body">
                      <div className="accordion-inner p-56">
                        <ul className="list-group list-group-flush">
                          {option.subOptions.map((subOption: SubOption, i: number) => {
                            return (
                              <li key={subOption.key()} className="list-group-item">
                                <input type="checkbox" checked={(this.props.formData['subFunctions'] as SubOption[]).find((e: SubOption) => e.id === subOption.id && e.optionId === option.id) != null} name="list" id={subOption.key()} onChange={() => this.onSelect(option.id, this.props.step.field!, subOption.id, 'subFunctions')} hidden />
                                <label className="hstack" htmlFor={subOption.key()}>
                                  <div className="checkbox-custom checkbox-custom-lg"></div>
                                  <div className="w-100">
                                    {subOption.title}
                                    {subOption.description && (
                                      <p className="suboption-description">{subOption.description}</p>
                                    )}
                                  </div>
                                </label>

                              </li>
                            )
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  getTemplateType4() {
    let options = this.props.step.options;
    const submitted = this.props.submitted;

    return (
      <div className="card card-no-hover">
        {!submitted && (
          <>
            <div className="form-group">
              <label>Waarom wenst u een prijs aan te vragen? *</label>
              <select className="form-control input-styled" disabled={this.props.submitting} value={this.props.formData["contactReason"][0]?.id} onChange={(e) => this.onSelect(Number.parseInt(e.target.value), 'contactReason')}>
                <option key='null' value='null'>Selecteer een keuze</option>
                {options.map((option, index) => (
                  <option key={index} value={option.id}>
                    {option.description}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group">
              <label>Naam *:</label>
              <input name='Name' disabled={this.props.submitting} required type="text" className="form-control input-styled" value={this.props.formData['naam']} placeholder="Geef je naam in" onChange={(e) => this.props.onTextInputChange!(e.target.value, "naam")} />
            </div>

            <div className="form-group">
              <label>E-Mail *:</label>
              <input name='E-mail' disabled={this.props.submitting} required type="email" className="form-control input-styled" value={this.props.formData['email']} placeholder="Geef je e-mail in" onChange={(e) => this.props.onTextInputChange!(e.target.value, "email")} />
            </div>

            <div className="form-group">
              <label>Telefoonnummer:</label>
              <input name='Phone' disabled={this.props.submitting} type="text" className="form-control input-styled" value={this.props.formData['phoneNumber']} placeholder="Geef je telefoonnummer in" onChange={(e) => this.props.onTextInputChange!(e.target.value, "phoneNumber")} />
            </div>

            <div className="form-group">
              <label>Bedrijf:</label>
              <input name='Company' disabled={this.props.submitting} type="text" className="form-control input-styled" value={this.props.formData['company']} placeholder="Geef de naam van je bedrijf in" onChange={(e) => this.props.onTextInputChange!(e.target.value, "company")} />
            </div>

            <div className="form-group">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="acceptprivacypolicy" checked={this.props.formData['acceptprivacypolicy'] === true} onChange={(e) => this.props.onTextInputChange!(e.target.checked as any, "acceptprivacypolicy")} />
                <label className="form-check-label" htmlFor="acceptprivacypolicy">
                  Ik ga akkoord met de <a href="https://www.codecraft.be/privacy-beleid" target="_blank">privacy policy</a>
                </label>
              </div>
            </div>


            <div className="form-group">
              {!this.props.submitting &&
                <button className="btn btn-blue-outline px-0 w-100 btn btn-submit" onClick={this.props.onSubmit}>Bereken de prijs van mijn app</button>
              }
              {this.props.submitting &&
                <button className="btn btn-blue-outline px-0 w-100 btn btn-submit">Bezig met berekenen..</button>
              }
            </div>
          </>
        )}

        {submitted && (
          <>
            <div className="row">
              <div className="col-12 thank-form">
                <h3>Bedankt voor uw aanvraag!</h3>
                <br />
                <p>Op basis van de informatie die je hebt opgegeven, hebben we een schatting van de kosten berekend en deze naar je e-mailadres gestuurd.<br /><br />
                </p>
                <p>
                  Heb je nog vragen of wil je meer informatie? Bel ons op het nummer <a href="tel:+32 472 37 91 10">+32 472 37 91 10</a>, mail ons op <a href="mailto:info@codecraft.be">info@codecraft.be</a> of vul het <a href="https://www.codecraft.be/contact" target="_blank">contactformulier</a> op onze website in.
                </p>
                <p>
                  Bedankt om gebruik te maken van onze calculator!
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-6">
                <button className="btn btn-blue-outline px-0 w-100" onClick={this.props.onEditCurrentRequest}>Mijn berekening aanpassen</button>
              </div>
              <div className="col-6">
                <button className="btn btn-blue-outline px-0 w-100" onClick={this.props.onStartNewRequest}>Een nieuwe berekening maken</button>
              </div>
            </div>
          </>
        )}
      </div>
    )
  }

  render(): React.ReactNode {
    return (
      <TransitionGroup className="stepItemsContainer" childFactory={child => React.cloneElement(
        child,
        { classNames: this.state.fadeClass }
      )}>
        <CSSTransition
          key={this.props.step.number}
          timeout={500}
          classNames={this.state.fadeClass}
        >
          <div className="row g-3 g-md-4 stepItem">
            {this.props.step.templateType !== TemplateType.Form && (
              <>
                {this.props.step.options &&
                  this.props.step.options.length > 0 &&
                  this.props.step.options.map((item: Option, i: number) => (
                    <React.Fragment key={item.id}>
                      {this.props.step.templateType === TemplateType.SimpleSelector &&
                        this.getTemplateType1(item)}
                      {this.props.step.templateType === 2 &&
                        this.getTemplateType2(item)}
                      {this.props.step.templateType === TemplateType.ListSelector &&
                        this.getTemplateType3(item)}
                    </React.Fragment>
                  ))}
              </>
            )}
            {this.props.step.templateType === TemplateType.Form && (
              <>
                {this.getTemplateType4()}
              </>
            )}
          </div>
        </CSSTransition>
      </TransitionGroup>
    );
  }
}

export default StepItem;
